import { SessionType } from 'interfaces/types'

export const DATA_TRACKING_ACTION_BY_SESSION: {
  [key in SessionType]?: string
} = {
  [SessionType.ARTICLES]: 'Read Related Articles',
  [SessionType.EMBEDDING_RISKSCREENER]: 'Check Risk Screener',
  [SessionType.EMBEDDING_DOCTORS]: 'Find a Doctor',
  [SessionType.CLINIC_LOCATORS]: 'Find a Clinic',
  [SessionType.VIDEOS]: 'Video Icon Click',
  [SessionType.CLICKABLE_BANNER]: 'Dynamic CTA Click',
  [SessionType.EMBEDDING_RISKSCREENER_MULTI]: 'Multi banner',
  [SessionType.COMMUNITY_WITH_POSTS]: 'Together Embedded',
  [SessionType.ECOMMERCE_PRODUCS]: 'Eshop Product Click',
  [SessionType.LEADGEN]: 'Voucher Click',
  [SessionType.SOYA_EXTERNAL_LINK]: 'Open Soya Page',
  [SessionType.CHAT_WITH_EXPERT]: 'Chat with Doctor - Move to Middle Chat',
  [SessionType.SOYA_OPEN_CHAT]: 'Ask the Expert - Start Chat',
  [SessionType.STATIC_BANNER]: 'Custom Navigator',
  [SessionType.CUSTOMIZED_NAVIGATOR]: 'Custom Navigator',
  [SessionType.CONTENT_EXPERT]: 'Health Care Professional',
  [SessionType.HEALTH_TOOL]: 'Health Tool Click',
  [SessionType.CUSTOMIZED_BLOCK]: 'Customized Block',
}

export function getSpecifySessionBgByPath(isRoche?: boolean) {
  if (isRoche) {
    return {
      [SessionType.EMBEDDING_DOCTORS]: 'transparent',
      [SessionType.EMBEDDING_RISKSCREENER]: '#00BEBF',
      [SessionType.CLICKABLE_BANNER]: '#E7FFFE',
      [SessionType.VIDEOS]: '#E7FFFE',
    } as { [key in SessionType]: string }
  }
  return null
}
